import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEOSchema from '../../components/SEOSchema';
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export default function HomePage() {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  // URLパラメータからのスクロールとフォーカス
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const targetId = params.get('jump');
    if (targetId) {
      console.log("Jump to:", targetId);
      
      const timer = setTimeout(() => {
        const element = document.getElementById(targetId);
        
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });

          const firstInput = element.querySelector('input, textarea, select') as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        }
      }, 500); // 描画待ちの時間ms
      return () => clearTimeout(timer);
    }
  }, []);
 
  
  // GA4 CTAクリックイベント
  const handleCtaClick = (label: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'MstCTA_click', {
        'event_category': 'MasterCTA',
        'event_label': label
      });
    }
  };
  
  return (
    <>
      <SEOSchema />
      <div className="min-h-screen bg-white">
        {/* Navigation */}
        <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              <div className="flex items-center">
                <h1 className="text-xl font-bold text-gray-900">セロトニン活性療法協会</h1>
              </div>
              
              <div className="hidden md:flex items-center space-x-8">
                <button onClick={() => scrollToSection('overview')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">講座概要</button>
                <button onClick={() => scrollToSection('symptoms')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">対応症状</button>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">受講者の声</button>
                <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">よくある質問</button>
                <button onClick={() => {handleCtaClick('cta0'); scrollToSection('cta');}} className="bg-teal-600 text-white px-6 py-3 rounded-full hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">講座に申し込む</button>
              </div>

              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-gray-700 cursor-pointer">
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>

          {mobileMenuOpen && (
            <div className="md:hidden bg-white border-t border-gray-200">
              <div className="px-4 py-4 space-y-3">
                <button onClick={() => scrollToSection('overview')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer whitespace-nowrap">講座概要</button>
                <button onClick={() => scrollToSection('symptoms')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer whitespace-nowrap">対応症状</button>
                <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer whitespace-nowrap">受講者の声</button>
                <button onClick={() => scrollToSection('faq')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer whitespace-nowrap">よくある質問</button>
                <button onClick={() => {handleCtaClick('cta0sp'); scrollToSection('cta');}}  className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer whitespace-nowrap">講座に申し込む</button>
              </div>
            </div>
          )}
        </nav>

        {/* Hero Section */}
        <section className="relative pt-20 min-h-max flex flex-col max-w-6xl mx-auto items-center">
          <div className="inset-0 z-0">
            <img 
              src="https://serotonin-kyoukai.or.jp/image/masterlp/lp1_3.jpeg" 
              alt="セロトニン活性療法" 
              /* className="hidden sm:block w-full object-cover object-top" */
              className="block w-full object-cover object-top"
            />
            {/* スマホ用画像（必要に応じて差し替え）
            <img 
              src="https://serotonin-kyoukai.or.jp/image/masterlp/lp1_3sp.jpeg" 
              alt="セロトニン活性療法" 
              className="block sm:hidden w-full object-cover object-top"
            /> */}
          </div>

          <div className="relative sm:absolute z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:-bottom-px">
            <div className="text-center text-white">
              <div className="hidden">
                <p className="text-lg sm:text-xl mb-4 font-medium">自律神経・慢性痛の患者さんで</p>
                <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  「結果が安定しない」と<br className="sm:hidden" />感じている整体師へ
                </h2>
                
                <div className="max-w-3xl mx-auto mb-8">
                  <p className="text-xl sm:text-2xl mb-8 leading-relaxed">
                    それは、あなたの技術が足りないのではありません。<br />
                    <span className="text-teal-300 font-bold">"脳と自律神経の状態"</span>を扱えていないだけです。
                  </p>
                  
                  <p className="text-lg sm:text-xl mb-8 leading-relaxed pt-2">
                    セロトニン活性療法マスター講座で、<br />
                    どこに行っても改善しない患者さんの<br />
                    <span className="text-yellow-300 font-bold text-2xl">「最後の砦」</span> になりませんか？
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto mb-12">
                  <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg p-6">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-brain-line text-4xl text-teal-300"></i>
                    </div>
                    <p className="text-sm font-medium">直接、脳にアプローチする<br />治療業界唯一の手技</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg p-6">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-time-line text-4xl text-teal-300"></i>
                    </div>
                    <p className="text-sm font-medium">15分で変化を体感<br />（検査で確認）</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg p-6">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-line-chart-line text-4xl text-teal-300"></i>
                    </div>
                    <p className="text-sm font-medium">圧・回数・時間を数値化<br />再現性が高い</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-lg p-6">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-hand-heart-line text-4xl text-teal-300"></i>
                    </div>
                    <p className="text-sm font-medium">力はいりません<br />女性・高齢者にも安全</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <button onClick={() => {handleCtaClick('cta1'); scrollToSection('contact');}} className="bg-teal-600 text-white px-6 lg:px-8 py-4 rounded-full text-lg font-bold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap">
                  <i className="ri-arrow-right-circle-line mr-2"></i>講座に申し込む
                </button>
                <button onClick={() => {handleCtaClick('trial1'); scrollToSection('trial_sec');}} className="hidden bg-gray-500 backdrop-blur-sm text-white border-2 border-white px-6 lg:px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap">
                  まずは体験会に申し込む
                </button>
                <button onClick={() => scrollToSection('schedule')} className="bg-gray-500 backdrop-blur-sm text-white border-2 border-white px-6 lg:px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap">
                  日程・会場を確認する
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* FV Catch & CTA Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <p className="text-xl sm:text-2xl text-gray-900 leading-relaxed mb-6">
                薬に頼らず、自律神経の不調を根本から改善する
                <strong className="text-teal-700">「本物の技術」</strong>
                をあなたの院に。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                多くの治療家が挫折する自律神経アプローチ。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                脳科学に基づいた
                <strong className="text-teal-700">『セロトニン活性療法』</strong>
                で、他院が治せない患者さんを救えるようになりませんか？
              </p>

              <div className="hidden">
                <div className="inline-block bg-teal-50 border-2 border-teal-200 rounded-xl px-6 py-4 mb-8">
                  <p className="text-lg font-bold text-teal-700">
                    ＼まずはその効果を、あなた自身で体感してください／
                  </p>
                </div>

                <div className="bg-gradient-to-r from-teal-600 to-blue-600 text-white rounded-2xl p-8 mb-8 max-w-3xl mx-auto">
                  <p className="text-lg font-medium mb-2">【特別開催】</p>
                  <p className="text-2xl sm:text-3xl font-bold leading-tight">
                    セロトニン活性療法 マスター講座
                    <br />
                    1日体験＆説明会
                  </p>
                </div>

                <button
                  onClick={() => scrollToSection('trial_sec')}
                  className="bg-red-600 text-white px-10 py-5 rounded-full text-xl font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-check-line mr-2"></i>
                  体験会に申し込む<br className="sm:hidden" />（限定割引あり）
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Target Audience */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                こんな整体師の方におすすめです
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {[
                { icon: 'ri-heart-pulse-line', text: '自律神経系（不眠・めまい・耳鳴り・不安・パニック・動悸など）の患者さんが増えている' },
                { icon: 'ri-refresh-line', text: '施術直後は変わるが、戻りが早いケースが多い' },
                { icon: 'ri-question-line', text: '患者さんに「なぜ必要か」をうまく説明できず、継続につながらない' },
                { icon: 'ri-file-list-3-line', text: '骨格・筋膜・内臓まで学んだが、それでも限界を感じている' },
                { icon: 'ri-money-dollar-circle-line', text: '自費メニューを作りたいが、根拠と再現性が不安' },
                { icon: 'ri-group-line', text: '紹介・リピートが安定せず、売上が読めない' }
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100">
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-3xl text-teal-600`}></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Problem Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                なぜ整体だけでは<br className="sm:hidden" />「自律神経・慢性痛」が<br className="sm:hidden" />安定しないのか？
              </h2>
            </div>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <p className="text-lg">
                多くの整体師が、構造（骨格・筋肉・筋膜）を整える技術を磨いています。<br />
                それでも、自律神経・慢性痛・メンタル症状は、なかなか安定しない。
              </p>
              
              <p className="text-2xl font-bold text-center text-teal-600">なぜでしょうか？</p>
              
              <div className="bg-teal-50 border-l-4 border-teal-600 p-8 rounded-lg">
                <p className="text-lg font-medium mb-4">それは、患者さんの体は</p>
                <p className="text-xl font-bold text-gray-900">
                  <strong>「構造」だけでなく、「脳と神経の状態」</strong>に大きく左右されているからです。
                </p>
              </div>

              <p className="text-lg">
                睡眠、ストレス、安心感、生活環境、感情…。<br />
                これらが変わるたびに、<br />
                脳は自律神経の出力を変え、筋緊張や内臓の働きまで影響します。
              </p>

              <div className="bg-yellow-50 border border-yellow-200 p-8 rounded-lg text-center">
                <p className="text-xl font-bold text-gray-900 mb-2">つまり、</p>
                <p className="text-lg">
                  構造を整えても、神経が過緊張のままでは、元に戻りやすい。<br />
                  <strong className="text-red-600">これが、結果が安定しない最大の理由です。</strong>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What is Serotonin Therapy */}
        <section id="overview" className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                セロトニン活性療法とは？
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
                セロトニン活性療法は、<br />
                <strong>「脳と自律神経の状態」そのものにアプローチする新しい整体です。</strong>
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="bg-white rounded-lg p-8 shadow-md text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-brain-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">セロトニン神経系を活性化し</h3>
              </div>
              <div className="bg-white rounded-lg p-8 shadow-md text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-heart-pulse-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">自律神経のバランスを整え</h3>
              </div>
              <div className="bg-white rounded-lg p-8 shadow-md text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-refresh-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">痛み・不安・過緊張を根本からリセット</h3>
              </div>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-md max-w-4xl mx-auto">
              <p className="text-lg text-gray-700 leading-relaxed text-center">
                筋肉を無理に押すのではなく、<br />
                <strong className="text-teal-600">リズム・圧・場所を整えることで、脳の反応を引き出すため、</strong><br />
                強刺激・力技は一切不要です。
              </p>
            </div>
          </div>
        </section>

        {/* Why 15 Minutes */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                なぜ「15分で体感」できるのか？
              </h2>
              <p className="text-xl text-gray-700 mb-8">この手技は、感覚頼りの施術ではありません。</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="bg-teal-50 rounded-lg p-8 text-center border-2 border-teal-200">
                <div className="text-5xl font-bold text-teal-600 mb-2">圧</div>
                <p className="text-gray-700 font-medium">どれくらい</p>
              </div>
              <div className="bg-teal-50 rounded-lg p-8 text-center border-2 border-teal-200">
                <div className="text-5xl font-bold text-teal-600 mb-2">回数</div>
                <p className="text-gray-700 font-medium">何回</p>
              </div>
              <div className="bg-teal-50 rounded-lg p-8 text-center border-2 border-teal-200">
                <div className="text-5xl font-bold text-teal-600 mb-2">時間</div>
                <p className="text-gray-700 font-medium">何秒</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-teal-600 to-blue-600 text-white rounded-lg p-8 mb-12">
              <p className="text-xl text-center leading-relaxed">
                を明確に数値化し、<br />
                <strong className="text-2xl">「どこに、どんな刺激を、どれだけ与えると脳が反応するのか」</strong><br />
                を体系化しています。
              </p>
            </div>

            <div className="space-y-4 mb-8">
              {[
                { icon: 'ri-check-double-line', text: '再現性が高い' },
                { icon: 'ri-check-double-line', text: '経験年数に左右されにくい' },
                { icon: 'ri-check-double-line', text: '施術者が変わっても結果が出やすい' }
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-4 bg-gray-50 rounded-lg p-4">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <p className="text-lg font-medium text-gray-900">{item.text}</p>
                </div>
              ))}
            </div>

            <p className="text-xl text-center text-gray-700 font-bold">
              多くの受講者が、15分以内の施術で変化を体感しています。
            </p>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                この講座で、整体師として何が変わるのか？
              </h2>
              <p className="text-lg text-gray-700">
                セロトニン活性療法マスター講座を修了すると、次の変化が起こります。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  icon: 'ri-line-chart-line',
                  title: '結果が安定する',
                  description: '「良くなる人・ならない人」の差が小さくなる'
                },
                {
                  icon: 'ri-chat-3-line',
                  title: '説明力が上がる',
                  description: 'なぜこの施術が必要かを、患者さんが"納得"する'
                },
                {
                  icon: 'ri-money-dollar-circle-line',
                  title: '自費メニューとして成立',
                  description: '価値が伝わり、価格で比較されにくくなる'
                },
                {
                  icon: 'ri-repeat-line',
                  title: 'リピート・紹介が増える',
                  description: '「ここしかない」と言われる施術へ'
                },
                {
                  icon: 'ri-team-line',
                  title: '再現性が高い',
                  description: 'スタッフ指導・院の標準化が可能'
                }
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-3xl text-teal-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                      <p className="text-gray-700 leading-relaxed">→ {item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Curriculum */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                3回のスクーリングで、現場導入まで仕上げます
              </h2>
            </div>

            <div className="space-y-8">
              <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg p-8 border-l-4 border-teal-600">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full text-2xl font-bold flex-shrink-0">1</div>
                  <h3 className="text-2xl font-bold text-gray-900">第1回：技術指導</h3>
                </div>
                <ul className="space-y-3 ml-20">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">セロトニン神経を活性化させる具体的手技</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">圧・回数・時間の基準</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">変化を確認する検査法</span>
                  </li>
                </ul>
                <p className="mt-4 ml-20 text-teal-700 font-bold">→ その場で「15分体感」を再現できる</p>
              </div>

              <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg p-8 border-l-4 border-teal-600">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full text-2xl font-bold flex-shrink-0">2</div>
                  <h3 className="text-2xl font-bold text-gray-900">第2回：問診・説明実践</h3>
                </div>
                <ul className="space-y-3 ml-20">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">自律神経系の患者さんへの伝え方・納得の作り方</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">継続につながる治療計画の立て方</span>
                  </li>
                </ul>
                <p className="mt-4 ml-20 text-teal-700 font-bold">→ 「なぜこの施術が必要なのか」を言語化できる</p>
              </div>

              <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg p-8 border-l-4 border-teal-600">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full text-2xl font-bold flex-shrink-0">3</div>
                  <h3 className="text-2xl font-bold text-gray-900">第3回：総復習・臨床応用</h3>
                </div>
                <ul className="space-y-3 ml-20">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">現場で迷いやすい症例の修正</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                    <span className="text-gray-700">導入後の不安をすべて解消</span>
                  </li>
                </ul>
                <p className="mt-4 ml-20 text-teal-700 font-bold">→ すぐにメニュー化できる状態で修了</p>
              </div>
            </div>
          </div>
        </section>

        {/* Trial Event Section */}
        <div className="hidden">
          <div id="trial_sec"></div>
          <section id="trial-event" className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <div className="inline-block bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-bold mb-4">
                  特別開催
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                  セロトニン活性療法 マスター講座
                  <br />
                  <span className="text-teal-700">1日体験＆説明会</span>
                </h2>
                <p className="text-xl text-gray-700 mb-4 leading-relaxed">
                  <strong className="text-gray-900">「本当に効果があるのか？」「自分にも習得できるのか？」</strong>
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  そんな疑問を解消するため、まずは1日体験会へお越しください。
                </p>
                <p className="text-lg text-gray-600 leading-relaxed mt-2">
                  本講座でお伝えする技術の核となる部分を、実際に体験・実践できる1日限定のセミナーです。
                </p>
              </div>

              {/* 3 Benefits */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                <div className="bg-white rounded-xl p-8 shadow-md border-t-4 border-teal-500 text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                    <i className="ri-flashlight-line text-3xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">即効性を実感</h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    たった数分の施術でセロトニンが活性化し、体と脳が変化する感覚をご自身で体感できます。
                  </p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-md border-t-4 border-blue-500 text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
                    <i className="ri-brain-line text-3xl text-blue-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">科学的根拠に基づく理論の理解</h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    なぜ自律神経が整うのか、脳科学と生理学の視点から分かりやすく解説します。
                  </p>
                </div>

                <div className="bg-white rounded-xl p-8 shadow-md border-t-4 border-orange-500 text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
                    <i className="ri-hand-heart-line text-3xl text-orange-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">実際の技術指導</h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    現場ですぐに使える基礎テクニックを特別にお伝えします。
                  </p>
                </div>
              </div>

              {/* Pricing & Capacity */}
              <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-10 max-w-3xl mx-auto mb-10 border-2 border-amber-200">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                  <div className="text-center sm:text-left">
                    <p className="text-sm text-gray-800 mb-1">【開催日時】</p>
                    <p className="text-3xl font-bold text-gray-900">
                      6月 3日(水) <br />
                      <span className="text-2xl">13:00〜17:00</span>
                    </p>
                  </div>
                  <div className="text-center sm:text-left">
                    <p className="text-sm text-gray-800 mb-1">【参加費】</p>
                    <p className="text-lg text-gray-400 line-through">
                      通常 33,000円
                    </p>
                    <p className="text-4xl font-bold text-red-600 mt-1">
                      5,500円<span className="text-sm text-red-500">（税込）</span>
                    </p>
                    <p className="text-sm text-red-500 mt-1 font-medium">
                      ※期間限定特別価格
                    </p>
                  </div>
                </div>
                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-8">
                  <div className="text-center sm:text-left">
                    <p className="text-sm text-gray-800 mb-1">【定員】</p>
                    <p className="text-3xl font-bold text-gray-900">
                      限定 <span className="text-teal-600">9名</span>
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      ※少人数制で丁寧にお伝えするため
                    </p>
                  </div>
                  <div className="text-center sm:text-left">
                    <p className="text-sm text-gray-800 mb-1">【会場】</p>
                    <p className="text-xl text-yellow-600 mt-1">
                      <a href="https://www.hiro-kairo.com/" target="_blank" rel="noopener noreferrer" className="font-bold text-red-600 hover:underline">
                        ひろカイロ整体院
                      </a><br className="sm:hidden" />
                      <span className="text-sm text-gray-600 mt-1">（茨城県守谷市中央3-15-5）</span>
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      守谷駅 東口（八坂口）徒歩1分<br />
                      秋葉原駅からつくばエキスプレスで快速32分
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="text-center">
                <button
                  onClick={() => scrollToSection('trial_form')}
                  className="bg-red-600 text-white px-10 py-5 rounded-full text-xl font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-check-line mr-2"></i>
                  体験会に申し込む<br className="sm:hidden" />（限定割引あり）
                </button>
                <p className="text-sm text-gray-500 mt-4">
                  ※定員に達し次第、募集を締め切らせていただきます
                </p>
              </div>
            </div>
          </section>

          <section id="trial_form" className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <div className="inline-block bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-bold mb-4">
                  限定特別価格 5,500円
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                  1日体験＆説明会 お申し込み
                </h2>
                <p className="text-gray-700 text-lg">
                  以下のフォームより、体験会のお申し込みをお受けしています。
                </p>
              </div>

              {/* 体験会 Form */}
              <div id="experience-form" className="bg-white rounded-xl shadow-lg p-8 sm:p-10 border border-amber-200">
                <form name="asumeru_form" method="post" action="https://1lejend.com/stepmail/kd.php?no=cmuuxu" className="space-y-6">
                  <fieldset className="space-y-6">
                    <div>
                      <label htmlFor="touroku_name_pre" className="block text-sm font-bold text-gray-900 mb-2">
                        お名前 <span className="text-red-600">※</span>
                      </label>
                      <input 
                        type="text" 
                        name="touroku_name" 
                        id="touroku_name_pre" 
                        size={30}
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                        placeholder="山田 太郎"
                      />
                    </div>

                    <div>
                      <label htmlFor="touroku_kana_pre" className="block text-sm font-bold text-gray-900 mb-2">
                        フリガナ <span className="text-red-600">※</span>
                      </label>
                      <input 
                        type="text" 
                        name="touroku_kana" 
                        id="touroku_kana_pre" 
                        size={30}
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                        placeholder="ヤマダ タロウ"
                      />
                    </div>

                    <div>
                      <label htmlFor="touroku_mail_pre" className="block text-sm font-bold text-gray-900 mb-2">
                        メールアドレス <span className="text-red-600">※</span>
                      </label>
                      <input 
                        type="email" 
                        name="touroku_mail" 
                        id="touroku_mail_pre" 
                        size={60}
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                        placeholder="example@email.com"
                      />
                    </div>

                    <div>
                      <label htmlFor="touroku_tel_pre" className="block text-sm font-bold text-gray-900 mb-2">
                        電話番号 <span className="text-red-600">※</span>
                      </label>
                      <input 
                        type="tel" 
                        name="touroku_tel" 
                        id="touroku_tel_pre" 
                        size={20}
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                        placeholder="例：03-1234-5678"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="touroku_free1_pre" className="block text-sm font-bold text-gray-900 mb-2">
                        治療院名・所属
                      </label>
                      <input 
                        type="text" 
                        name="touroku_free1" 
                        id="touroku_free1_pre"
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                        placeholder="〇〇整体院"
                      />
                    </div>

                    <div>
                      <p className="block text-sm font-bold text-gray-900 mb-3">
                        日程 <span className="text-red-600">※</span>
                      </p>
                      <select 
                        name="touroku_free10"
                        id="touroku_free10_pre"
                        required
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm cursor-pointer mb-3"
                      >
                        <option value="2026/06/03(水) 13:00～17:00">2026/06/03(水) 13:00～17:00</option>
                      </select>
                    </div>

                    <div>
                      <p className="block text-sm font-bold text-gray-900 mb-3">
                        支払方法 <span className="text-red-600">※</span>
                      </p>
                      <div className="space-y-2">
                        <label htmlFor="touroku_free4_0_pre" className="flex items-center gap-3 cursor-pointer">
                          <input 
                            type="radio" 
                            required
                            name="touroku_free4" 
                            id="touroku_free4_0_pre" 
                            value="銀行振込(一括)"
                            className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-600 cursor-pointer"
                          />
                          <span className="text-sm text-gray-700">銀行振込(一括)</span>
                        </label>
                        <label htmlFor="touroku_free4_1_pre" className="flex items-center gap-3 cursor-pointer">
                          <input 
                            type="radio" 
                            required
                            name="touroku_free4" 
                            id="touroku_free4_1_pre" 
                            value="Paypal(分割)"
                            className="w-5 h-5 text-teal-600 border-gray-300 focus:ring-teal-600 cursor-pointer"
                          />
                          <span className="text-sm text-gray-700">Paypal(分割)</span>
                        </label>
                      </div>
                    </div>

                    <div>
                      <label htmlFor="touroku_free5_pre" className="block text-sm font-bold text-gray-900 mb-2">
                        備考・お問い合わせ
                      </label>
                      <textarea 
                        name="touroku_free5" 
                        id="touroku_free5_pre" 
                        cols={35}
                        rows={7}
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm resize-y"
                        placeholder="ご質問やご要望がございましたらご記入ください"
                      ></textarea>
                    </div>

                    <div className="bg-yellow-50 border border-red-400 rounded-lg p-6">
                      <div className="mb-4">
                        <p className="text-sm font-bold text-gray-900 mb-2">受講規約 <span className="text-red-600">※</span></p>
                        <p className="text-sm text-gray-700 mb-2">●規約はこちらからご確認ください●</p>
                        <div className="flex flex-col gap-2 mb-4">
                          <a href="https://serotonin-kyoukai.or.jp/kiyaku/" target="_blank" rel="noopener noreferrer" className="text-orange-800 hover:underline text-sm">
                            → 受講規約
                          </a>
                        </div>
                      </div>
                      <label htmlFor="touroku_free3_0_pre" className="flex items-start gap-3 cursor-pointer">
                        <input 
                          type="checkbox" 
                          name="touroku_free3[]" 
                          id="touroku_free3_0_pre" 
                          value="受講規約に同意します"
                          required
                          className="mt-1 w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-600 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">受講規約に同意します</span>
                      </label>
                    </div>

                    <input type="hidden" name="touroku_free6" value="Readdyマスター講座LP" />
                    <input type="hidden" name="no" value="cmuuxu" />
                    <input type="hidden" name="action" value="kakunin" />

                    <div className="text-center">
                      <button 
                        type="submit"
                        name="submit"
                        id="confirmBtn"
                        className="bg-red-600 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        体験会に申し込む<br className="sm:hidden" />（限定割引あり）
                      </button>
                    </div>

                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg space-y-4">
                      <div>
                        <p className="text-sm font-bold text-gray-900 mb-2">※重要※</p>
                        <p className="text-sm text-gray-700 leading-relaxed">
                          お申し込み後、確認メールが『contact@serotonin-kyoukai.com』より送信されます。<br />
                          受信できていない場合、メールアドレスの誤りや、迷惑メール扱いとなりゴミ箱や迷惑メールフォルダに振り分けられている可能性があります。
                        </p>
                      </div>
                      <div className="border-t border-yellow-200 pt-4">
                        <p className="text-sm text-gray-700 leading-relaxed">
                          ※プライバシー保護のため、SSL暗号化通信に対応したフォームです。<br />
                          入力されたデータは暗号化が施されて安全に送信されます。
                        </p>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>  {/* 体験会申込フォームEnd */}
            </div>
          </section>
        </div>

        {/* Symptoms Section */}
        <section id="symptoms" className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                自律神経症状に悩む患者さんを、<br />
                "その場しのぎ"ではなく、根本から変えたい整体師へ
              </h2>
              <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
                骨格・筋膜・内臓を整えても、<br />
                自律神経・慢性症状が安定しないケースはありませんか？<br /><br />
                それは、症状の"発信源"である<strong className="text-teal-600">脳と神経の状態にアプローチできていないから</strong>です。<br />
                以下は、現場で特に多い４つの代表的な症状です。
              </p>
            </div>

            <div className="space-y-12">
              {/* Insomnia */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-teal-600 to-blue-600 text-white p-6">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full">
                      <i className="ri-moon-line text-3xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold">不眠（眠れない・途中で目が覚める・寝ても疲れが取れない）</h3>
                  </div>
                </div>
                <div className="p-8">
                  <div className="mb-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-user-voice-line text-teal-600"></i>
                      整体師の現場で、こんな患者さんはいませんか？
                    </h4>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start gap-2">
                        <span className="text-teal-600 mt-1">•</span>
                        <span className="text-gray-700">「体は楽になったのに、夜になると眠れない」</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-teal-600 mt-1">•</span>
                        <span className="text-gray-700">「首・背中を整えても、めまいが再発する」</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-teal-600 mt-1">•</span>
                        <span className="text-gray-700">「病院では"自律神経ですね"で終わってしまった」</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">なぜ、整体だけでは改善が安定しないのか？</h4>
                    <p className="text-gray-700 leading-relaxed">
                      不眠の多くは、構造の問題ではなく、<br />
                      <strong className="text-red-600">脳の過緊張（覚醒モードのまま）</strong> が原因です。<br />
                      筋肉が緩んでも、神経の誤作動が続けば症状は戻ります。
                    </p>
                  </div>

                  <div className="bg-teal-50 border-l-4 border-teal-600 p-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">セロトニン活性療法で何が変わるのか？</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      脳の過敏状態を鎮め、神経の出力を安定させることで、
                    </p>
                    <ul className="space-y-2 mb-4">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">施術後に「頭が静かになった」「眠気が出た」</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">睡眠の質が安定しやすくなる</span>
                      </li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed">
                      という変化が起こります。<br />
                      <strong className="text-teal-700">"メンタル系に踏み込める整体師"</strong> に変わります。
                    </p>
                  </div>
                </div>
              </div>

              {/* Dizziness */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full">
                      <i className="ri-contrast-drop-2-line text-3xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold">めまい・ふらつき（検査では異常なし）</h3>
                  </div>
                </div>
                <div className="p-8">
                  <div className="mb-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-user-voice-line text-blue-600"></i>
                      整体師の現場で、こんなケースはありませんか？
                    </h4>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start gap-2">
                        <span className="text-blue-600 mt-1">•</span>
                        <span className="text-gray-700">首・背中を整えても、めまいが再発する</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-600 mt-1">•</span>
                        <span className="text-gray-700">「病院では異常なし」と言われ、不安だけが残っている</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-blue-600 mt-1">•</span>
                        <span className="text-gray-700">ストレスや疲労が溜まると悪化する</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">なぜ、改善が安定しないのか？</h4>
                    <p className="text-gray-700 leading-relaxed">
                      めまいの多くは、構造よりも<br />
                      <strong className="text-red-600">脳幹・自律神経のバランス異常</strong> による"誤作動"です。<br />
                      骨格が整っても、神経の誤作動が続けば症状は出続けます。
                    </p>
                  </div>

                  <div className="bg-blue-50 border-l-4 border-blue-600 p-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">セロトニン活性療法で何が変わるのか？</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      脳の過敏状態を鎮め、神経の出力を安定させることで、
                    </p>
                    <ul className="space-y-2 mb-4">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">ふらつきの軽減</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">不安感の減少</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-blue-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">「何が起きているか」を患者に説明できる</span>
                      </li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed">
                      <strong className="text-blue-700">"メンタル系に踏み込める整体師"</strong> になります。
                    </p>
                  </div>
                </div>
              </div>

              {/* Panic */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-6">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full">
                      <i className="ri-heart-pulse-line text-3xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold">パニック・強い不安（動悸・息苦しさ・予期不安）</h3>
                  </div>
                </div>
                <div className="p-8">
                  <div className="mb-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-user-voice-line text-purple-600"></i>
                      整体師の現場で、こんな患者さんはいませんか？
                    </h4>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start gap-2">
                        <span className="text-purple-600 mt-1">•</span>
                        <span className="text-gray-700">「検査では異常なし。でも突然苦しくなる」</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-purple-600 mt-1">•</span>
                        <span className="text-gray-700">施術中は楽だが、日常で再発する</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-purple-600 mt-1">•</span>
                        <span className="text-gray-700">薬への不安が強く、根本的に改善したいと言われる</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">なぜ、整体だけでは限界があるのか？</h4>
                    <p className="text-gray-700 leading-relaxed">
                      パニックや強い不安は、筋肉の問題ではなく、<br />
                      <strong className="text-red-600">脳の"危険スイッチ"が過剰に入る状態</strong>です。<br />
                      体を緩めても、脳が「危険だ」と誤認していれば症状は出続けます。
                    </p>
                  </div>

                  <div className="bg-purple-50 border-l-4 border-purple-600 p-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">セロトニン活性療法で何が変わるのか？</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      セロトニン神経を活性化し、脳の過剰な警戒モードを鎮めることで、
                    </p>
                    <ul className="space-y-2 mb-4">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-purple-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">動悸・息苦しさの頻度が下がる</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-purple-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">「大丈夫な感覚」を取り戻しやすくなる</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-purple-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">患者に"なぜ起きるか"を説明できる</span>
                      </li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed">
                      <strong className="text-purple-700">"メンタル系に踏み込める整体師"</strong> になります。
                    </p>
                  </div>
                </div>
              </div>

              {/* Chronic Pain */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-orange-600 to-red-600 text-white p-6">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full">
                      <i className="ri-pulse-line text-3xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold">慢性痛（腰痛・肩こり・頭痛など、原因がはっきりしない痛み）</h3>
                  </div>
                </div>
                <div className="p-8">
                  <div className="mb-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-user-voice-line text-orange-600"></i>
                      整体師の現場で、こんなことはありませんか？
                    </h4>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start gap-2">
                        <span className="text-orange-600 mt-1">•</span>
                        <span className="text-gray-700">画像では異常がないのに、痛みが続く</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-orange-600 mt-1">•</span>
                        <span className="text-gray-700">施術直後は楽だが、数日で戻る</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-orange-600 mt-1">•</span>
                        <span className="text-gray-700">ストレスや天候で痛みが変動する</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">なぜ、慢性痛は戻りやすいのか？</h4>
                    <p className="text-gray-700 leading-relaxed">
                      慢性痛の多くは、組織の損傷ではなく、<br />
                      <strong className="text-red-600">脳が"痛みを出し続けるモード"に入っている状態</strong>です。<br />
                      構造を整えても、脳の痛み出力が変わらなければ再発します。
                    </p>
                  </div>

                  <div className="bg-orange-50 border-l-4 border-orange-600 p-6">
                    <h4 className="text-lg font-bold text-gray-900 mb-2">セロトニン活性療法で何が変わるのか？</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      脳の痛み調節機能にアプローチすることで、
                    </p>
                    <ul className="space-y-2 mb-4">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-orange-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">痛みの感じ方そのものが変わる</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-orange-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">「なぜ慢性化したのか」を患者に説明できる</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-orange-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">その場しのぎではない施術が可能になる</span>
                      </li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed">
                      <strong className="text-orange-700">"慢性痛の本質に触れられる整体師"</strong> になります。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Common Root Cause */}
            <div className="mt-16 bg-gradient-to-r from-teal-600 to-blue-600 text-white rounded-lg p-10">
              <h3 className="text-3xl font-bold text-center mb-6">
                症状は違っても、共通する根本原因があります
              </h3>
              <p className="text-xl text-center mb-8 leading-relaxed">
                不眠・めまい・パニック・慢性痛…。<br />
                一見まったく違う症状ですが、共通しているのは、
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-8 text-center mb-8">
                <p className="text-3xl font-bold">👉 脳と自律神経の"誤作動・過緊張"</p>
              </div>
              <p className="text-xl text-center leading-relaxed">
                セロトニン活性療法は、<br />
                この"司令塔"である脳と神経の状態に直接アプローチすることで、<br />
                <strong className="text-yellow-300 text-2xl">「戻りにくい改善」</strong> を目指す整体です。
              </p>
            </div>

            {/* Why This Matters */}
            <div className="mt-12 bg-white rounded-lg shadow-lg p-10">
              <h3 className="text-3xl font-bold text-center text-gray-900 mb-8">
                だからこそ、整体師の武器になります
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  { icon: 'ri-chat-check-line', text: '「なぜこの症状が出ているのか」を説明できる' },
                  { icon: 'ri-lightbulb-line', text: '「なぜ戻っていたのか」を構造的に伝えられる' },
                  { icon: 'ri-money-dollar-circle-line', text: 'その場しのぎではない、根拠ある自費メニューが作れる' },
                  { icon: 'ri-star-line', text: '自律神経・慢性症状を"専門分野"にできる整体師へ' }
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4 bg-teal-50 rounded-lg p-6">
                    <div className="w-10 h-10 flex items-center justify-center bg-teal-600 text-white rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <p className="text-gray-700 font-medium leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section - Before Evidence */}
        <section className="py-16 bg-gradient-to-r from-teal-600 to-blue-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 leading-tight">
              自律神経・慢性症状を専門分野にしたい整体師の方へ
            </h3>
            <p className="text-lg text-white/90 mb-8">
              セロトニン活性療法で、結果が安定する整体を手に入れませんか？
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button onClick={() => {handleCtaClick('cta2'); scrollToSection('contact');}} className="bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-bold text-center cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-fill mr-2"></i>講座に申し込む
              </button>
              <button onClick={() => {handleCtaClick('trial2'); scrollToSection('trial_sec');}} className="hidden bg-white/20 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full text-lg font-bold text-center cursor-pointer whitespace-nowrap">
                <i className="ri-chat-1-line mr-2"></i>体験会を申し込む
              </button>
            </div>
          </div>
        </section>

        {/* Evidence */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                科学的エビデンスと第三者評価
              </h2>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
                セロトニン活性療法は、<br />
                脳波測定・唾液セロトニン測定・心理テストなどを用いて検証され、
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="relative rounded-lg overflow-hidden border-2 border-teal-200 shadow-lg">
                <div className="absolute inset-0">
                  <img 
                    src="https://serotonin-kyoukai.or.jp/image/masterlp/img_islis.png" 
                    alt="国際生命情報科学学会での発表" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative z-10 p-8 text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mx-auto mb-4">
                    <i className="ri-award-line text-3xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 bg-white/60 px-4 py-2 rounded-lg inline-block">国際生命情報科学学会(ISLIS)にて発表</h3>
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden border-2 border-teal-200 shadow-lg">
                <div className="absolute inset-0">
                  <img 
                    src="https://serotonin-kyoukai.or.jp/image/masterlp/img_ronbun.png" 
                    alt="医学誌に論文掲載" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative z-10 p-8 text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mx-auto mb-4">
                    <i className="ri-file-text-line text-3xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 bg-white/60 px-4 py-2 rounded-lg inline-block">医学誌に論文掲載</h3>
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden border-2 border-teal-200 shadow-lg">
                <div className="absolute inset-0">
                  <img 
                    src="https://serotonin-kyoukai.or.jp/image/masterlp/img_media.png" 
                    alt="専門誌・テレビなどメディア掲載" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative z-10 p-8 text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mx-auto mb-4">
                    <i className="ri-tv-line text-3xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 bg-white/60 px-4 py-2 rounded-lg inline-block">専門誌・テレビなどメディア掲載</h3>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-teal-600 to-blue-600 text-white rounded-lg p-8 text-center">
              <p className="text-xl leading-relaxed">
                「感覚的な療法」ではなく、<br />
                <strong className="text-2xl">"脳と神経の反応を科学的に検証した整体"</strong>です。
              </p>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                受講者の声(整体師より)
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  name: '日下田 一之先生',
                  location: '彩整体',
                  title: '高単価かつ、長期的に通っていただけるリピートメニューができたので、助かっています!',
                  text: '栃木県で自律神経専門院を営む日下田です。本療法は教わった通りに施術すれば必ず結果が出て、患者様に心から喜んでいただけます。科学的根拠に基づき自信を持って説明できる上、高単価かつリピート率も高いため、経営面でも非常に助かっています。シンプルで確実に成果が出るこの療法との出会いに感謝しかありません。'
                },
                {
                  name: '舘野 真人先生',
                  location: '根っこの整体院',
                  title: 'うつ症状や自律神経症状の悩みを解決できるようになり、近隣の院とは大きな差別化を図ることができました',
                  text: 'うつや自律神経、不眠、不妊等に悩む先生に強く推薦します。心身両面へのアプローチを学んだことで、以前感じていた施術の限界を突破できました。患者様からも「体が軽く、頭もスッキリする」と喜びの声が絶えず、今では他院との大きな差別化に繋がっています。一人でも多くの治療家に広まり、救われる方が増えることを願います。'
                },
                {
                  name: '冨田 公央先生',
                  location: 'からだ支援株式会社',
                  title: '起立性調節障害のお子さんが学校に行けるようになったり、睡眠の不規則な自閉症のお子さんが眠れるようになってきました',
                  text: '自律神経専門院を経営する中で、スタッフとの技術差や自身の体力消耗が課題でした。セロトニン活性療法は初日から即実践できる再現性の高さが魅力です。確かなエビデンスにより、起立性調節障害や自閉症など難治性の症例でも早期に信頼を得られています。誰でも安全かつ簡単に結果を出せるこの技術は、院の大きな武器です。'
                },
                {
                  name: '阿萬 ようか先生',
                  location: '女性専用整体院ココロモ',
                  title: '患者様の中には、何をしても良くならなかった皮膚の湿疹が良くなったケースもあり、これには驚きました',
                  text: '女性専門の整体師です。以前は長時間施術による疲労が悩みでしたが、セロトニン活性療法で劇的に改善しました。短時間で誰でも再現でき、科学的根拠に基づいた説明で患者様の納得度も高いです。導入後、患者様の改善スピードが明らかに加速しました。確かなデータに基づき、自信を持って推薦します。'
                },
                {
                  name: '戸田 吉和先生',
                  location: 'とだ鍼灸指圧治療院',
                  title: '通常、半年〜1年ぐらいかけて学ぶ内容を、たった3回の講座で全て学べます',
                  text: '自律神経専門院を経営する中、症状改善と経営の両立を求めて参加しました。3ヶ月という短期間ながら、通常半年かかるほど濃密な内容を即臨床に活かせる形で学べます。トークスクリプト等も完備されており、ビジネス展開もスムーズ。誠実な滝本先生が研究を重ねたセロトニン活性療法は、自信を持って推薦できる本物の技術です。'
                },
                {
                  name: '藤嶋 琢也先生',
                  location: 'たくや整骨院',
                  title: '問診から検査、施術に至るまでが1つのパッケージとして完成していますので、どんな人でもしっかりと結果が出せます',
                  text: '岩手県で専門院を経営する中で、既存の技術に感じていた「足りないピース」を埋めるため受講しました。本療法は科学的エビデンスが盤石で、問診から施術まで完成されたパッケージのため、誰でも確実に結果を出せます。導入後、患者様の改善スピードが明らかに加速しました。確かなデータに基づき、自信を持って推薦します。'
                }
              ].map((testimonial, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="bg-gradient-to-r from-teal-500 to-green-500 p-6 text-white">
                    <h3 className="font-bold text-base leading-snug">{testimonial.title}</h3>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                      ))}
                    </div>
                    <p className="text-gray-700 text-sm leading-relaxed mb-4">{testimonial.text}</p>
                    <div className="border-t border-gray-200 pt-4">
                      <p className="font-bold text-gray-900">{testimonial.name}</p>
                      <p className="text-sm text-gray-600">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Instructor Profile */}
        <section id="instructor" className="py-24 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <p className="text-sm font-semibold text-teal-600 uppercase tracking-widest mb-3">Instructor Profile</p>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                開発者 / メイン講師
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                セロトニン活性療法の開発者であり、現場に立ち続ける臨床家が、直接指導します。
              </p>
            </div>

            {/* Main Profile Card */}
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl overflow-hidden mb-12">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
                {/* Photo side */}
                <div className="lg:col-span-2 relative min-h-80">
                  <img
                    src="https://serotonin-kyoukai.or.jp/image/masterlp/img_takimoto2.jpg"
                    alt="滝本 裕之（たきもと ひろゆき）"
                    title="セロトニン活性療法開発者 滝本 裕之（たきもと ひろゆき）"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-teal-800/80 to-transparent p-6">
                    <p className="text-white text-sm font-medium">一般社団法人セロトニン活性療法協会 代表理事</p>
                    <p className="text-white text-xl font-bold">滝本 裕之（たきもと ひろゆき）</p>
                    <p className="text-teal-200 text-sm mt-1">自律神経専門「ひろカイロ整体院」院長</p>
                  </div>
                </div>

                {/* Content side */}
                <div className="lg:col-span-3 p-8 lg:p-10 flex flex-col justify-center">
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">滝本 裕之（たきもと ひろゆき）</h3>
                    <p className="text-teal-700 font-semibold text-sm mb-4">一般社団法人セロトニン活性療法協会 代表理事 / 自律神経専門「ひろカイロ整体院」院長</p>
                    <div className="w-12 h-0.5 bg-teal-500 mb-6"></div>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      長年にわたり、原因不明の不調や自律神経トラブルに悩む数多くの患者を救済。圧倒的な臨床データと脳科学に基づく検証を重ね、再現性の高い<strong className="text-teal-700">『セロトニン活性療法』</strong>を確立した。
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                      現在、全国の治療家・セラピストに向けて本物の技術を普及させるべく尽力している。
                    </p>
                  </div>

                  {/* Key credentials */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {[
                      { icon: 'ri-award-line', text: '国際生命情報科学学会(ISLIS)発表' },
                      { icon: 'ri-file-paper-2-line', text: '医学誌・専門誌に複数論文掲載' },
                      { icon: 'ri-tv-2-line', text: 'テレビ・メディア多数取材・掲載' },
                      { icon: 'ri-group-line', text: '全国120院以上の卒業生を輩出' },
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 bg-white rounded-lg px-4 py-3 border border-teal-100">
                        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                          <i className={`${item.icon} text-xl text-teal-600`}></i>
                        </div>
                        <p className="text-sm text-gray-800 font-medium leading-snug">{item.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Career Timeline */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-12">
              {/* Timeline */}
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-600 rounded-full">
                    <i className="ri-history-line text-white text-base"></i>
                  </div>
                  キャリアと研究の歩み
                </h3>
                <div className="space-y-0">
                  {[
                    { year: '2003年', event: 'ひろカイロ整体院 開業', note: '守谷市にて自律神経・慢性痛専門院として開業' },
                    { year: '2010年', event: 'セロトニン研究開始', note: '慢性症状の根本原因として脳神経系に着目' },
                    { year: '2015年', event: '療法の体系化完成', note: '圧・回数・時間を数値化し、再現性を確立' },
                    { year: '2018年', event: 'ISLIS学会で発表', note: '国際生命情報科学学会にて研究成果を発表' },
                    { year: '2020年', event: '医学誌に論文掲載', note: '査読付き医学誌へ複数の研究論文が採択' },
                    { year: '2022年', event: 'マスター講座開講', note: '全国の整体師向け指導プログラムを正式開始' },
                  ].map((item, i) => (
                    <div key={i} className="flex gap-4 pb-6 relative">
                      <div className="flex flex-col items-center">
                        <div className="w-3 h-3 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0 mt-1.5 z-10"></div>
                        {i < 5 && <div className="w-0.5 bg-teal-200 flex-grow mt-1"></div>}
                      </div>
                      <div className="pb-2">
                        <p className="text-xs font-bold text-teal-600 mb-0.5">{item.year}</p>
                        <p className="font-bold text-gray-900 text-sm">{item.event}</p>
                        <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{item.note}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Philosophy & Message */}
              <div className="flex flex-col gap-6">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-600 rounded-full">
                      <i className="ri-chat-quote-line text-white text-base"></i>
                    </div>
                    受講者へのメッセージ
                  </h3>
                  <div className="bg-teal-50 border-l-4 border-teal-600 rounded-lg p-6 relative">
                    <i className="ri-double-quotes-l text-teal-200 text-5xl absolute top-4 right-4"></i>
                    <p className="text-gray-800 leading-relaxed mb-4 relative z-10">
                      「あなたの技術は、もう十分です。」
                    </p>
                    <p className="text-gray-700 leading-relaxed text-sm relative z-10">
                      私がこの療法を開発したのは、施術後に「良くなった」と言われても、数日で戻ってしまう患者さんを何度も見てきたからです。
                      構造だけを整えても、脳の過緊張が解けなければ、症状は必ず戻ります。
                    </p>
                    <p className="text-gray-700 leading-relaxed text-sm mt-3 relative z-10">
                      セロトニン活性療法を身につけてから、私の院では「最後の砦」として遠方から患者さんが来るようになりました。
                      この技術は、感覚や才能ではなく、<strong className="text-teal-700">誰でも再現できる体系</strong>として整理してあります。
                      あとは、やるかどうかだけです。
                    </p>
                    <div className="mt-6 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-teal-300">
                        <img
                          src="https://serotonin-kyoukai.or.jp/image/masterlp/img_takimoto_s.jpg"
                          alt="滝本 裕之（たきもと ひろゆき）"
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 text-sm">滝本 裕之（たきもと ひろゆき）</p>
                        <p className="text-xs text-teal-600">一般社団法人セロトニン活性療法協会 代表理事</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Specialties */}
                <div className="bg-gray-50 rounded-lg p-6">
                  <h4 className="font-bold text-gray-900 mb-4 text-sm">専門・得意分野</h4>
                  <div className="flex flex-wrap gap-2">
                    {['自律神経失調症', '不眠・睡眠障害', 'パニック障害', 'めまい・ふらつき', '慢性腰痛', '起立性調節障害', '過緊張・不安', '慢性頭痛', 'セロトニン神経研究', '整体師指導・育成'].map((tag, i) => (
                      <span key={i} className="bg-teal-100 text-teal-800 text-xs font-medium px-3 py-1.5 rounded-full">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Media & Achievements */}
            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 text-center mb-8">実績・メディア掲載</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                  {
                    icon: 'ri-award-line',
                    color: 'bg-yellow-100 text-yellow-700',
                    title: '学術発表',
                    detail: '国際生命情報科学学会(ISLIS)にて研究成果を発表。脳波・唾液セロトニン測定による検証'
                  },
                  {
                    icon: 'ri-file-text-line',
                    color: 'bg-teal-100 text-teal-700',
                    title: '医学誌掲載',
                    detail: '査読付き医学誌・専門誌に複数の研究論文が掲載。科学的エビデンスを積み重ね'
                  },
                  {
                    icon: 'ri-tv-line',
                    color: 'bg-orange-100 text-orange-700',
                    title: 'テレビ・メディア',
                    detail: 'テレビ番組や業界専門誌など、多数のメディアで取材・紹介実績あり'
                  },
                  {
                    icon: 'ri-book-open-line',
                    color: 'bg-green-100 text-green-700',
                    title: '指導実績',
                    detail: '全国120院以上の卒業生を輩出。3,200症例以上の改善事例をサポート'
                  },
                ].map((item, i) => (
                  <div key={i} className="bg-white rounded-lg p-6 text-center border border-gray-100">
                    <div className={`w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-4 ${item.color}`}>
                      <i className={`${item.icon} text-2xl`}></i>
                    </div>
                    <h4 className="font-bold text-gray-900 text-sm mb-2">{item.title}</h4>
                    <p className="text-xs text-gray-600 leading-relaxed">{item.detail}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                よくある質問
              </h2>
            </div>

            <div className="space-y-4">
              {[
                {
                  question: '特別な資格や経験は必要ですか？',
                  answer: 'いいえ。整体師であれば、どなたでも習得可能です。力も必要ありません。'
                },
                {
                  question: '強い刺激はありませんか？',
                  answer: 'ありません。リズムと軽い刺激を使うため、高齢者や女性にも安全です。'
                },
                {
                  question: 'すぐ現場で使えますか?',
                  answer: 'はい。3回のスクーリングで、施術・説明・メニュー化まで完成します。'
                },
                {
                  question: '分割払いは可能ですか？',
                  answer: 'はい、可能です。月16,500円〜の分割払いに対応しております。'
                },
                {
                  question: '遠方からの参加は可能ですか？',
                  answer: 'はい、全国各地から受講者が集まっています。宿泊施設のご案内も可能です。'
                },
                {
                  question: '修了後のサポートはありますか？',
                  answer: 'はい。修了後も質問や相談ができるサポート体制を整えております。'
                },
                {
                  question: '整体師（商業目的）ではなく、家族や友人知人に施術してあげたい目的で受講したいのですが可能ですか？',
                  answer: `はい。受講可能ですのでご安心ください。
本講座では、手技だけでなく「安全な進め方」「刺激量の判断」「施術前後の確認」「説明のポイント」なども含めて体系的に学んでいただけます。
そのため、ご家族などへのケアを目的とした受講でも、学びを活かしていただけます。

なお、講座内でお伝えする内容は協会の規約・ルールの範囲内での取り扱いをお願いしております（教材の取り扱い・情報の公開範囲など）。
詳細はお申込み時にご案内いたします。`
                }
              ].map((faq, index) => (
                <div key={index} className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full text-left p-6 flex items-center justify-between hover:bg-gray-100 transition-colors cursor-pointer"
                  >
                    <span className="font-bold text-gray-900 pr-4">{faq.question}</span>
                    <i className={`${openFaq === index ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-teal-600 flex-shrink-0`}></i>
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-6">
                      <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">{faq.answer.trim()}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Schedule & CTA */}
        <section id="schedule" className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                開催概要
              </h2>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
              <div className="space-y-6">
                <div className="border-b border-gray-200 pb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-calendar-line text-teal-600"></i>
                    【第25期】開催日程
                  </h3>
                  <div className="space-y-2 ml-8">
                    <p className="text-gray-700">1 技術指導 令和8年7月8日(水)</p>
                    <p className="text-gray-700">2 問診実践 令和8年8月19日(水)</p>
                    <p className="text-gray-700">3 総復習 令和8年9月2日(水)</p>

                    <p className="text-red-600">第25期は受付を終了いたしました。
                      次回の開催をお待ちください。
                    </p>
                  </div>
                </div>

                <div className="border-b border-gray-200 pb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-time-line text-teal-600"></i>
                    時間
                  </h3>
                  <p className="text-gray-700 ml-8">午後1時〜午後6時</p>
                </div>

                <div className="border-b border-gray-200 pb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-map-pin-line text-teal-600"></i>
                    会場
                  </h3>
                  <div className="text-gray-700 ml-8 space-y-1">
                    <p>茨城県守谷市　セロトニン活性療法協会本部</p>
                    <p className="font-bold">
                      <a 
                        href="https://hiro-chiro-seitai.com/access.html" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-teal-600 hover:text-teal-700 hover:underline"
                      >
                        『ひろカイロ整体院』
                      </a>
                    </p>
                    <p className="mt-3">〒302-0115 茨城県守谷市中央3-15-5</p>
                    <p className="mt-2 pt-2">つくばエキスプレス線／関東鉄道常総線</p>
                    <p>秋葉原駅からつくばエキスプレスで快速32分</p>
                    <p>「守谷駅」東口（八坂口）徒歩1分</p>
                  </div>
                </div>

                <div className="border-b border-gray-200 pb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-group-line text-teal-600"></i>
                    定員
                  </h3>
                  <p className="text-gray-700 ml-8">9名（少人数制）</p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <i className="ri-money-dollar-circle-line text-teal-600"></i>
                    受講料
                  </h3>
                  <div className="ml-8 space-y-2">
                    <p className="text-xl">330,000円（税込）</p>
                    <p className="text-sm text-gray-600">※分割払い対応（月16,500円〜）</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* 体験会のご案内セクション */}
        <div className="hidden">
          <section id="experience" className="py-16 bg-slate-50">
            <div className="max-w-4xl mx-auto px-4">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6">
                  セロトニン活性療法マスター講座 <br className="md:hidden" />
                  <span className="text-teal-600">体験会のご案内</span>
                </h2>
                <p className="text-slate-600 leading-relaxed max-w-2xl mx-auto">
                  文章でお伝えするには限界があります。<br />
                  そこで、実際の講座内容の一部を直接体験できる機会を設けました。
                </p>
              </div>

              {/* 内容カード */}
              <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-slate-100 mb-10">
                <div className="bg-teal-600 py-4 px-6">
                  <h3 className="text-white font-bold text-center">体験会で学べる内容（一部）</h3>
                </div>
                <div className="p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                    {[
                      '脳科学に基づいた理論解説', '滝本による技術実演・体感'
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-teal-500 text-lg"></i>
                        <span className="text-slate-700 text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>
                  
                  {/* 価格表示 */}
                  <div className="border-t border-dashed border-slate-200 pt-8 text-center">
                    <p className="text-sm text-slate-500 mb-1">通常受講料 33,000円のところ</p>
                    <div className="flex justify-center items-baseline gap-2">
                      <span className="text-sm font-bold text-slate-800">体験会特別価格</span><br className="md:hidden" />
                      <span className="text-4xl font-black text-red-600">5,500</span>
                      <span className="text-lg font-bold text-red-600">円(税込)</span>
                    </div>
                    <p className="text-xs text-slate-400 mt-2">※巷のセミナーでは語られない「不都合な真実」にも言及します。</p>
                  </div>
                </div>
              </div>

              {/* 開催情報 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                  <h4 className="font-bold text-teal-700 mb-3 flex items-center gap-2">
                    <i className="ri-calendar-event-line"></i> 開催日時
                  </h4>
                  <p className="text-slate-800 font-bold">2026年 6月 3日(水)</p>
                  <p className="text-slate-600 text-sm">13:00～17:00</p>
                </div>
                <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                  <h4 className="font-bold text-teal-700 mb-3 flex items-center gap-2">
                    <i className="ri-map-pin-2-line"></i> 開催場所
                  </h4>
                  <p className="text-slate-800 font-bold"><a href="https://hiro-chiro-seitai.com/access/" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline">ひろカイロ整体院</a></p>
                  <p className="text-slate-600 text-[11px] leading-tight">
                    茨城県守谷市中央3-15-5 <br />
                    守谷駅 東口（八坂口）徒歩1分<br />
                    秋葉原駅からつくばエキスプレスで快速32分
                  </p>
                </div>
              </div>

              {/* 定員・お支払い等の補足情報 */}
              <div className="bg-white/50 border border-slate-200 rounded-xl p-4 mb-10 flex flex-wrap justify-center gap-x-8 gap-y-2">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] bg-red-100 text-red-600 font-bold px-2 py-0.5 rounded">定員</span>
                  <span className="text-sm font-bold text-slate-700">9名（先着順）</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[10px] bg-slate-200 text-slate-600 font-bold px-2 py-0.5 rounded">支払方法</span>
                  <span className="text-sm font-bold text-slate-700">銀行振込 / クレジット(Paypal)決済</span>
                </div>
              </div>
              
              {/* CTA */}
              <div className="text-center">
                <button onClick={() => {handleCtaClick('trial2'); scrollToSection('trial_form');}} className="bg-red-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-red-700 transition-colors">
                  <i className="ri-send-plane-fill mr-2"></i>体験会に申し込む
                </button>
              </div>

            </div>
          </section>
        </div>

        {/* Final CTA */}
        <section id="cta" className="py-20 bg-gradient-to-r from-teal-600 to-blue-600 text-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-5xl font-bold mb-6 leading-tight">
              どこに行っても改善しなかった患者さんの<br />
              「最後の砦」になる整体師へ
            </h2>
            
            <div className="max-w-3xl mx-auto mb-12">
              <p className="text-xl leading-relaxed mb-6">
                あなたの技術は、もう十分です。<br />
                足りなかったのは、<strong className="text-yellow-300">"脳と自律神経を扱う視点"</strong> だけ。
              </p>
              
              <p className="text-2xl font-bold leading-relaxed">
                セロトニン活性療法マスター講座で、<br />
                <span className="text-yellow-300">「結果が安定する整体」</span> を、あなたの武器にしませんか？
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
              <button onClick={() => {handleCtaClick('cta3'); scrollToSection('contact');}} className="bg-white text-teal-600 px-10 py-5 rounded-full text-xl font-bold text-center cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-fill mr-2"></i>講座に申し込む
              </button>
              <button onClick={() => {handleCtaClick('trial3'); scrollToSection('trial_form');}} className="hidden bg-white/20 backdrop-blur-sm text-white border-2 border-white px-10 py-5 rounded-full text-xl font-bold text-center cursor-pointer whitespace-nowrap">
                まずは体験会に申し込む
              </button>
            </div>

            <p className="text-sm opacity-90">定員に達し次第、募集を締め切らせていただきます</p>
          </div>
        </section>

        {/* Contact Form */}
        <section id="contact" className="py-20 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                セロトニン活性療法マスター講座お申し込み
              </h2>
              <p className="text-red-600 font-bold">
                第25期は受付を終了いたしました。<br />
                次回の開催をお待ちください。
              </p>
              <p className="hidden text-gray-700">
                講座へのお申し込みをご希望の方は、<br />
                以下のフォームよりお申し込みください。
              </p>
            </div>

            <form name="asumeru_form" method="post" action="https://1lejend.com/stepmail/kd.php?no=dnmXzks" className="bg-gray-50 rounded-lg p-8 shadow-md">
              <fieldset className="space-y-6">
                <div>
                  <label htmlFor="touroku_name" className="block text-sm font-bold text-gray-900 mb-2">
                    お名前 <span className="text-red-600">※</span>
                  </label>
                  <input 
                    type="text" 
                    name="touroku_name" 
                    id="touroku_name" 
                    size={30}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="山田 太郎"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_kana" className="block text-sm font-bold text-gray-900 mb-2">
                    フリガナ <span className="text-red-600">※</span>
                  </label>
                  <input 
                    type="text" 
                    name="touroku_kana" 
                    id="touroku_kana" 
                    size={30}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="ヤマダ タロウ"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_mail" className="block text-sm font-bold text-gray-900 mb-2">
                    メールアドレス <span className="text-red-600">※</span>
                  </label>
                  <input 
                    type="email" 
                    name="touroku_mail" 
                    id="touroku_mail" 
                    size={60}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="example@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_tel" className="block text-sm font-bold text-gray-900 mb-2">
                    電話番号 <span className="text-red-600">※</span>
                  </label>
                  <input 
                    type="tel" 
                    name="touroku_tel" 
                    id="touroku_tel" 
                    size={20}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="090-1234-5678"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_zip" className="block text-sm font-bold text-gray-900 mb-2">
                    郵便番号 <span className="text-red-600">※</span>
                  </label>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-700">〒</span>
                    <input 
                      type="text" 
                      name="touroku_zip" 
                      id="touroku_zip" 
                      size={20}
                      required
                      className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                      placeholder="123-4567"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="touroku_addr" className="block text-sm font-bold text-gray-900 mb-2">
                    住所 <span className="text-red-600">※</span>
                  </label>
                  <input 
                    type="text" 
                    name="touroku_addr" 
                    id="touroku_addr" 
                    size={60}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="東京都渋谷区〇〇1-2-3"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_free1" className="block text-sm font-bold text-gray-900 mb-2">
                    企業・治療院名
                  </label>
                  <input 
                    type="text" 
                    name="touroku_free1" 
                    id="touroku_free1"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="〇〇整体院"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_free2" className="block text-sm font-bold text-gray-900 mb-2">
                    ホームページURL
                  </label>
                  <input 
                    type="text" 
                    name="touroku_free2" 
                    id="touroku_free2"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="https://example.com"
                  />
                </div>

                <div>
                  <p className="block text-sm font-bold text-gray-900 mb-3">
                    希望会場 <span className="text-red-600">※</span>
                  </p>
                  <select 
                    name="touroku_free7"
                    id="touroku_free7"
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm cursor-pointer mb-3"
                  >
                    <option value="【第26期】守谷会場">【第26期】守谷会場</option>
                  </select>
                </div>

                <div>
                  <p className="block text-sm font-bold text-gray-900 mb-3">
                    支払方法 <span className="text-red-600">※</span>
                  </p>
                  <div className="space-y-2">
                    <label htmlFor="touroku_free4_0" className="flex items-center gap-3 cursor-pointer">
                      <input 
                        type="radio" 
                        required
                        name="touroku_free4" 
                        id="touroku_free4_0" 
                        value="銀行振込(一括)"
                        className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-600 cursor-pointer"
                      />
                      <span className="text-sm text-gray-700">銀行振込(一括)</span>
                    </label>
                    <label htmlFor="touroku_free4_1" className="flex items-center gap-3 cursor-pointer">
                      <input 
                        type="radio" 
                        required
                        name="touroku_free4" 
                        id="touroku_free4_1" 
                        value="Paypal(分割)"
                        className="w-5 h-5 text-teal-600 border-gray-300 focus:ring-teal-600 cursor-pointer"
                      />
                      <span className="text-sm text-gray-700">Paypal(分割)</span>
                    </label>
                  </div>
                </div>

                <div>
                  <label htmlFor="touroku_free9" className="block text-sm font-bold text-gray-900 mb-2">
                    何で知りましたか？
                  </label>
                  <select 
                    name="touroku_free9"
                    id="touroku_free9"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm cursor-pointer mb-3"
                  >
                    <option value="セロトニン活性療法協会HP">セロトニン活性療法協会HP</option>
                    <option value="セロトニン活性療法協会（自律神経でお悩みの方へ）">セロトニン活性療法協会（自律神経でお悩みの方へ）</option>
                    <option value="治療院（院名や先生を下にご記入ください）">治療院（院名や先生を下にご記入ください）</option>
                    <option value="ひろカイロ整体院HP">ひろカイロ整体院HP</option>
                    <option value="脳活性療法セミナー">脳活性療法セミナー</option>
                    <option value="テレビ">テレビ</option>
                    <option value="チラシ">チラシ</option>
                    <option value="書籍・雑誌">書籍・雑誌</option>
                    <option value="その他">その他</option>
                  </select>
                  <input 
                    type="text" 
                    name="touroku_free8" 
                    id="touroku_free8"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="治療院名(○○院 □□先生)・書名などをご記入ください"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_free10" className="block text-sm font-bold text-gray-900 mb-2">
                    紹介者
                  </label>
                  <input 
                    type="text" 
                    name="touroku_free10" 
                    id="touroku_free10"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm"
                    placeholder="紹介者がいる場合はお名前を記入ください"
                  />
                </div>

                <div>
                  <label htmlFor="touroku_free5" className="block text-sm font-bold text-gray-900 mb-2">
                    備考・お問い合わせ
                  </label>
                  <textarea 
                    name="touroku_free5" 
                    id="touroku_free5" 
                    cols={35}
                    rows={7}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-600 text-sm resize-y"
                    placeholder="ご質問やご要望がございましたらご記入ください"
                  ></textarea>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                  <div className="mb-4">
                    <p className="text-sm font-bold text-gray-900 mb-2">受講規約 <span className="text-red-600">※</span></p>
                    <p className="text-sm text-gray-700 mb-2">●規約はこちらからご確認ください●</p>
                    <div className="flex flex-col gap-2 mb-4">
                      <a href="https://serotonin-kyoukai.or.jp/kiyaku/" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline text-sm">
                        → 受講規約
                      </a>
                      <a href="https://serotonin-kyoukai.or.jp/dvdkiyaku/" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline text-sm">
                        → DVD利用規約
                      </a>
                    </div>
                  </div>
                  <label htmlFor="touroku_free3_0" className="flex items-start gap-3 cursor-pointer">
                    <input 
                      type="checkbox" 
                      name="touroku_free3[]" 
                      id="touroku_free3_0" 
                      value="受講規約に同意します"
                      required
                      className="mt-1 w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-600 cursor-pointer"
                    />
                    <span className="text-sm text-gray-700">受講規約・DVD利用規約に同意します</span>
                  </label>
                </div>

                <input type="hidden" name="touroku_free6" value="ReaddyLP">
                </input><input type="hidden" name="no" value="dnmXzks" />
                <input type="hidden" name="action" value="kakunin" />

                <div className="text-center">
                  <button 
                    disabled
                    type="submit"
                    name="submit"
                    id="confirmBtn"
                    className="bg-teal-600 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    申し込む
                  </button>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg space-y-4">
                  <div>
                    <p className="text-sm font-bold text-gray-900 mb-2">※重要※</p>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      お申し込み後、確認メールが『contact@serotonin-kyoukai.com』より送信されます。<br />
                      受信できていない場合、メールアドレスの誤りや、迷惑メール扱いとなりゴミ箱や迷惑メールフォルダに振り分けられている可能性があります。
                    </p>
                  </div>
                  <div className="border-t border-yellow-200 pt-4">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      ※プライバシー保護のため、SSL暗号化通信に対応したフォームです。<br />
                      入力されたデータは暗号化が施されて安全に送信されます。
                    </p>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gradient-to-br from-teal-600 to-blue-700 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              <div>
                <h3 className="text-xl font-bold mb-4">セロトニン活性療法協会</h3>
                <p className="text-sm text-white/80 leading-relaxed">
                  脳と自律神経にアプローチする、<br />
                  科学的根拠に基づいた整体技術を提供しています。
                </p>
              </div>
              
              <div>
                <h4 className="text-lg font-bold mb-4">クイックリンク</h4>
                <ul className="space-y-2 text-sm">
                  <li><button onClick={() => scrollToSection('overview')} className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">講座概要</button></li>
                  <li><button onClick={() => scrollToSection('symptoms')} className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">対応症状</button></li>
                  <li><button onClick={() => scrollToSection('testimonials')} className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">受講者の声</button></li>
                  <li><button onClick={() => scrollToSection('faq')} className="text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">よくある質問</button></li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-lg font-bold mb-4">お問い合わせ</h4>
                <ul className="space-y-2 text-sm text-white/80">
                  <li className="flex items-center gap-2">
                    <i className="ri-mail-line"></i>
                    <span>contact@serotonin-kyoukai.com</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="border-t border-white/20 pt-8 text-center text-sm text-white/80">
              <p className="mb-2">&copy; 2025 セロトニン活性療法協会. All rights reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}